import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    sectionTitle: {
        fontSize: `16px`
    }
}));
export default useStyles;